module.exports = __webpack_public_path__ + "website/img/core8_2.387394fa.png";